<div class="progress-bar-container" [ngClass]="containerClass()">
    @if (label || showProgressLabel) {
        <div class="progress-label">
            @if (label) {
                {{ label }}
            }
            @if (showProgressLabel) {
                @if (label) {
                    -
                }
                <span>{{ animatedPercentage() }}%</span>
            }
        </div>
    }
    <div class="progress-bar-track" [style.background]="mode === 'custom' ? lightColor : null">
        <div
            class="progress-bar-fill"
            [ngStyle]="progressStyle()"
            [style.background]="
                mode === 'custom' ? (solid ? darkColor : 'linear-gradient(90deg, ' + lightColor + ', ' + darkColor + ')') : null
            "
        >
            <div
                class="progress-indicator"
                [style.border-color]="mode === 'custom' ? darkColor : null"
                appTooltip
                trigger="hover"
                [componentData]="showProgressValue ? animatedPercentage() + '%' : ''"
                position="top"
                [showDelay]="200"
                [hideDelay]="200"
            ></div>
        </div>
    </div>
</div>
